import styled from "styled-components";

export const ContentHolder = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px;

  .page-heading {
    padding: 20px 0;
    box-shadow: unset;
  }

  .filters-holder {
    margin-top: 20px;

    .select-search-submit {
      input {
        border-radius: 8px;
      }
    }
  }
`;

export const SelectScheduleContainer = styled.div`
  .datetime-result-list {
    margin-top: 30px;
  }

  .container-dates-options.container-times-options {
    display: flex;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    margin: 0 auto;
    justify-content: center;
    box-sizing: border-box;
  }

  .container-times-options {
    margin-top: 30px;
  }

  .available-months {
    margin-top: 30px;
  }

  .error {
    margin-top: 30px;
  }

  .dates-list {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
  }

  .text-md {
    font-size: 1.5rem;
  }
`;

export const ButtonsHolder = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 30px;
  width: 100%;
  max-width: 500px;
  margin: 40px auto 0;
`;

export const ModalStyle = styled.div`
  padding: 20px 0;

  h3 {
    padding: 0;
    width: 100%;
    font-family: var(--font-display);
    font-style: normal;
    font-weight: normal;
    font-size: 1.5rem;
    line-height: 1.75rem;
    letter-spacing: 0.5px;
    color: var(--color-purple);
    margin-bottom: 0;
  }

  .heading {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(195, 195, 195, 0.5);
    margin-bottom: 27px;

    button {
      padding: 0;
      height: auto !important;
      background: none;
      border: none;
    }
  }

  .separator {
    margin-top: 20px;
  }

  .address-items h3 {
    margin-bottom: 20px;
  }

  .order-item {
    margin-bottom: 20px;
    p {
      font-size: 1.12rem;
      margin: 0;
    }
    span {
      font-size: 1rem;
      word-break: break-word;
    }
  }

  .danger {
    background: red;
    border-color: red;

    &:hover {
      color: white;
    }
  }

  .accordion-items {
    margin-top: 10px;
    row-gap: 20px;
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(3, 250px);

    &.patients {
      margin-bottom: 20px;
    }
  }
`;
